// 出入库纪录

export default {
    path: "/outInRecords",
    name: "outInRecords",
    meta: { title: "出入库记录", icon: "outInWarehouseRecord" },
    children: [
      {
        path: "/outInRecords/outInRecordsList",
        name: "warehouseDateList",
        component: () => import(/* webpackChunkName: "warehouseDateList" */'@/views/warehouse/warehouseDate/warehouseDateList.vue'),
        meta: {title: "出入库记录", icon: "warehouseDateList"}
      },
      {
        path: "/outInRecords/warehouseDateRecord",
        name: "warehouseDateRecord",
        component: () => import(/* webpackChunkName: "warehouseDateRecord" */'@/views/warehouse/warehouseDate/warehouseDateRecord.vue'),
        meta: {title: "记录明细", icon: "warehouseDateRecord"}
      },
      {
        path: "/outInRecords/warehouseCycle",
        name: "warehouseCycle",
        component: () => import(/* webpackChunkName: "warehouseDateRecord" */'@/views/warehouse/warehouseDate/warehouseCycle.vue'),
        meta: {title: "产品库存周期", icon: "warehouseCycle"}
      },
      {
        path: "/outInRecords/warehouseProRecord",
        name: "warehouseProRecord",
        component: () => import(/* webpackChunkName: "warehouseProRecord" */'@/views/warehouse/warehouseDate/warehouseProRecord.vue'),
        meta: {title: "产品记录明细", icon: "user",sidebar: false,}
      }
  
    ]
  
  
  }